import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import SuccessImg from "../../assets/images/success-order.svg";
import SuccessImgFood from "../../assets/images/success-food.svg";
import { floatToPrice } from "../../functions/price_functions";

import { useAppConfig } from "../../hooks/useAppConfig";
import { FC, useEffect, useState } from "react";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";

import styles from "./index.module.css";
import { useOrder } from "../../hooks/useOrder";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { cpfMask, datetimeToDateBR } from "../../functions/mask";
import {
  OrderAddress,
  OrderType,
  ProductType,
} from "../../contexts/OrderContext";
import { MainButton } from "../../components/MainButton";
import Swal from "sweetalert2";
import { ImageLazy } from "../../components/ImageLazy";
import { CheckoutOrder } from "../../components/checkoutOrder/checkoutOrder";
import {
  SumaryOrder,
  SumaryOrderFinished,
} from "../../components/sumaryOrder/sumaryOrder.module";
import { InfoFinishedOrder } from "../../components/InfoFinishedOrder/InfoFinishedOrder";
import { InfoOrderItens } from "../../components/InfoOrderItens/InfoOrderItens";
import {
  InfoCustomer,
  InfoCustomerFinish,
} from "../../components/InfoCustomer/InfoCustomer";
import { InfoAddressOrder } from "../../components/InfoAddressOrder/InfoAddressOrder";
import { InfoSeller } from "../../components/InfoSeller/InfoSeller";
import { InfoPayment } from "../../components/InfoPayment/InfoPayment";
import { OrderObservation } from "../../components/OrderObservation/OrderObservation";
import { IntegrationType } from "../NewChoosePayment/NewChoosePayment";
import usePreventNavigation from "../../components/PreventBackNavigation/PreventBackNavigation";
import { useParams } from "react-router-dom";
import { useDiscount } from "../../hooks/useDiscount";
import { useSellerCart } from "../../contexts/sellerCartContext";

type StatusResponseType = {
  id: number;
  name: string;
  slug: string;
  order: number;
  displayStatusWebapp: boolean;
};

type Customer = {
  id: number;
  name: string;
  email: string;
  doc: string;
  password: null;
  pluginspaceId: number;
  hash: null;
  type: string;
  created: string;
  updated: string;
  cpf: string;
  inscEstadual: string;
  optinWhatsapp: boolean;
  birthDate: string;
  gender: string;
  lgpdDataAceiteCarta: string;
  customerCode: null;
  idTerms: null;
  deleted: null;
  customerAddresses: CustomerAddress[];
  customerPhones: CustomerPhone[];
  branchInsertCode: number;
  classifications: null;
  isInactive: boolean;
  customerStatus: string;
};

type CustomerPhone = {
  id: number;
  customerId: number;
  typePhone: string;
  numberPhone: string;
};

type CustomerAddress = {
  id: number;
  customerId: number;
  typeAddress: string;
  street: string;
  extra: null | string;
  number: string;
  district: string;
  city: string;
  reference: null;
  state: string;
  zipCode: string;
  country: string;
  ibgeCode: number;
  latlng: Latlng;
  placeId: string;
  created: string;
  updated: string;
};

type Latlng = {
  lat: number;
  lng: number;
};

interface Content {
  deliveryFee: number;
  customer: string;
  customerCpf: string;
  cnpj: string;
  customerEmail: string;
  phoneSms: string;
  cpfOrder: string;
  created: string;
  orderAddress: OrderAddressT;
  info: string;
  code: string;
  externalCodeERP: string;
  dataGateway: DataGateway;
  confirmApiTotvs: number;
}

interface DataGateway {
  code: number;
  capture: Capture;
  typeTicket: string;
  payment_id: string;
  cardTicket: string;
  statuscapture: number;
  payment: Payment;
  orderDate: string;
  status: string;
  nwr: string;
  hashc: string;
  vay: string;
  paymentType: number;
  ctk: string;
  gatewayName: string;
  value: number;
  portion_numInstallments: number;
  flagIdentifier: string;
  authorization: string;
  networkIdentifier: string;
  pluginspaceId: number;
  pluginconfigId: number;
  gatewayId: number;
  refundFlag: string;
  ip: string;
  codePay: string;
  orderIdExt: number;
  descConditionpay: string;
  paymentTermCode: number;
  bin: string;
  end: string;
  paymentData: IntegrationType | null;
}

interface Payment {
  order_id: number;
  orderDate: string;
  merchant_usn: number;
  nsu: number;
  customer_receipt: Customerreceipt;
  receipt: Customerreceipt;
}

interface Customerreceipt {
  customer_receipt: string;
  merchant_receipt: string;
}

interface Capture {
  Status: number;
  ReasonCode: number;
  ReasonMessage: string;
  ProviderReturnCode: string;
  ProviderReturnMessage: string;
  ReturnCode: string;
  ReturnMessage: string;
  Tid: string;
  ProofOfSale: string;
  AuthorizationCode: string;
  Content: Content;
  success: boolean;
}

interface Content {
  Status: number;
  ReasonCode: number;
  ReasonMessage: string;
  ProviderReturnCode: string;
  ProviderReturnMessage: string;
  ReturnCode: string;
  ReturnMessage: string;
  Tid: string;
  ProofOfSale: string;
  AuthorizationCode: string;
  Links: Link[];
}

interface Link {
  Method: string;
  Rel: string;
  Href: string;
}

interface OrderAddressT {
  address: string;
  cep: string;
  state: string;
  city: string;
  complement: string;
  district: string;
  name: string;
  number: string;
  reference: string;
  otherPersonToWithdrawal: null;
}

export type OrderIntegrationPlanType = {
  codePay: string;
  codePlan: number;
  nameGateway: string;
  paymentItemData: IntegrationType;
  nameBrand?: string;
  typePayment?: any;
};

const NewSuccessOrder: FC = () => {
  const { getAppConfig } = useAppConfig();
 const sellerCartContext = useSellerCart();;
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
  const { pluginspace_id } = useParams();
  const { dencryptOrderStorage } = useOrder();
  const [orderDate, setOrderDate] = useState("");
  const [status, setStatus] = useState<Array<StatusResponseType>>();
  const [statusOrder, setStatusOrder] = useState<StatusResponseType>();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [orderAddress, setOrderAddress] = useState<OrderAddress>();
  const [type, setType] = useState("");
  const [freight, setFreight] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);
  const [orderFinished, setOrderFinished] = useState<OrderType>();
  const [orderIdExt, setOrderIdExt] = useState("");
  const [typePluginSpace, setTypePluginSpace] = useState<string>("");
  const [observation, setObservation] = useState("");
  const [requestSynkar, setRequestSynkar] = useState("");
  const [externalCodeERP, setExternalCodeERP] = useState("");
  const [sellerInfo, setSellerInfo] = useState<any>(null);
  const [loadingHeader, setLoadingHeader] = useState(true);
  const [customer, setCustomer] = useState<Customer>();
  const [gateWayInfo, setGateWayInfo] = useState<DataGateway>();
  const [changePaymentValue, setChangePayment] = useState(0);
  const [cupomDiscount, setCupomDiscount] = useState("");
  const [paymentDiscount, setPaymentDiscount] = useState<{
    type: string;
    discountValue: string;
  } | null>();
  const [installment, setInstallment] = useState(0);
  const [installmentValue, setInstallmentValue] = useState(0);
  const [integrationPlanLocal, setIntegrationPlanLocal] =
    useState<OrderIntegrationPlanType>();

  const discountContext = useDiscount();

  useEffect(() => {
    registerAccess("success-order");
    discountContext.clearDiscounts();
    sellerCartContext.clearSellerCart();
    getConfig();
  }, []);

  const trunCat = (num: number, decimals: number) => {
    const formatter = Math.pow(10, decimals);
    const res = Math.floor(num * formatter) / formatter;
    return res;
  };

  async function loadOrder() {
    let orderIdExtNow = "";
    const orderFinalizedStorage = localStorage.getItem("orderFinalized");
    if (orderFinalizedStorage) {
      const orderFinalized = await dencryptOrderStorage(orderFinalizedStorage);
      if (orderFinalized) {
        setFreight(orderFinalized.freight);
        setChangePayment(orderFinalized.changePayment);
        //setName(customerStorage.name); // Carregando na linha 107
        setType(orderFinalized.type);
        if (
          orderFinalized.orderAddress &&
          orderFinalized.orderAddress.address
        ) {
          setOrderAddress(orderFinalized.orderAddress);
        }
        setTotal(orderFinalized.totalValue);
        setTotalWithoutDiscount(orderFinalized.totalValueWithoutDiscount);
        setOrderFinished(orderFinalized.order);
        setOrderIdExt(
          orderFinalized.orderIdExt ? orderFinalized.orderIdExt : ""
        );

        let paymentDiscount = null;

        if (
          discountContext.finishData.paymentDiscountCode &&
          discountContext.finishData.paymentDiscountTypeValue
        ) {
          paymentDiscount = {
            type: discountContext.finishData.paymentDiscountCode,
            discountValue:
              discountContext.finishData.paymentDiscountTypeValue.toString(),
          };
        }

        setPaymentDiscount(paymentDiscount);
        setInstallment(orderFinalized.installment || 1);
        setInstallmentValue(
          trunCat(Number(orderFinalized.installmentValue), 2)
        );
        setIntegrationPlanLocal(orderFinalized.integrationPlan);
        orderIdExtNow = orderFinalized.orderIdExt
          ? orderFinalized.orderIdExt
          : "";
      }
    }
    return orderIdExtNow;
  }

  async function getConfig() {
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    const type = await getThisPluginspace();

    setTypePluginSpace(type!.type);

    const orderIdExtNow = await loadOrder();
    await getOrder(orderIdExtNow);

    setInterval(async () => {
      if (window.location.pathname.includes("success-order")) {
        await getOrder(orderIdExtNow);
      }
    }, 30000);

    await getStatus();

    setLoading(false);
  }

  async function getOrder(orderIdExtNow?: string) {
    let customerCPF = 0;

    await api
      .post(
        `/api/orders/ext/${orderIdExtNow ? orderIdExtNow : orderIdExt}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        const orderResponse = response.data;
        if (orderResponse) {
          setOrderDate(datetimeToDateBR(orderResponse.data[0].created));
          setObservation(orderResponse.data[0].observation);
          setName(orderResponse.data[0].content.customer);
          if (orderResponse.data[0].type === "synkar") {
            const statusNow = orderResponse.data[0].orderStatus.sort(
              (a: any, b: any) => (a.id < b.id ? 1 : b.id < a.id ? -1 : 0)
            );
            const statusChange = orderResponse.data[0].status.find(
              (st: any) => st.id === statusNow[0].statusId
            );
            setStatusOrder(statusChange);
          } else {
            setStatusOrder(orderResponse.data[0].status[0]);
          }

          customerCPF = orderResponse.data[0].content.customerCpf
            ? orderResponse.data[0].content.customerCpf
            : orderResponse.data[0].content.cpfOrder;

          if (orderResponse.data[0].content.requestSynkar)
            setRequestSynkar(orderResponse.data[0].content.requestSynkar);
          if (orderResponse.data[0].content.externalCodeERP)
            setExternalCodeERP(orderResponse.data[0].content.externalCodeERP);

          if (
            orderResponse.data[0].cartCustomer &&
            orderResponse.data[0].cartCustomer.seller
          ) {
            setSellerInfo(orderResponse.data[0].cartCustomer.seller);
          }

          if (orderResponse.data[0].content.dataGateway) {
            setGateWayInfo(orderResponse.data[0].content.dataGateway);
          }

          if (
            (!orderAddress || !orderAddress.address) &&
            orderResponse.data &&
            orderResponse.data[0] &&
            orderResponse.data[0].content &&
            orderResponse.data[0].content.orderAddress
          ) {
            setOrderAddress(orderResponse.data[0].content.orderAddress);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        return null;
      });

    if (customerCPF) {
      await api
        .post(
          `/api/customer/filter`,
          {
            cpf: customerCPF,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response) => {
          const orderResponse = response.data;

          if (orderResponse.success) {
            const customer = orderResponse.data[0];
            setCustomer(customer);
          }
        })
        .catch((err) => {
          console.log(err);
          return null;
        });
    }
  }

  async function getStatus() {
    await api
      .get(`/api/status`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then((response) => {
        const statusReponse = response.data;
        const sts = statusReponse.data.filter(
          (manyStatus: StatusResponseType) =>
            manyStatus.displayStatusWebapp === true
        );
        setStatus(
          sts.sort((a: StatusResponseType, b: StatusResponseType) =>
            a.order > b.order ? 1 : b.order > a.order ? -1 : 0
          )
        );
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  const unlockSynkar = async () => {
    if (requestSynkar) {
      setLoading(true);
      await api
        .post(
          `/api/pluginconfig/filter`,
          {
            plugintemplateId: 108,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          if (
            response.data.data &&
            response.data.data[0] &&
            response.data.data[0].content &&
            response.data.data[0].content.able === "1"
          ) {
            const synkarData = response.data.data[0].content;
            await api
              .post(
                `/api/orders/unlock-synkar`,
                {
                  requestUuid: requestSynkar,
                  operationUuid: synkarData.operationCode,
                  clientId: synkarData.clientId,
                  clientSecret: synkarData.clientSecret,
                  orderIdExt,
                },
                {
                  headers: {
                    Authorization: `Bearer ${await getToken()}`,
                  },
                }
              )
              .then(async (response) => {
                setLoading(false);
                Swal.fire({
                  icon: "success",
                  title: "Trava desbloqueada!",
                  text: "Abra o robô e retire seu pedido.",
                }).then(() => window.location.reload());
              })
              .catch((e) => {
                setLoading(false);
                Swal.fire({
                  icon: "error",
                  title: "Erro!",
                  text: "Falha ao realizar desbloqueio.",
                });
              });
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: "Não foi possível capturar dados da integração Synkar.",
            });
          }
        })
        .catch((e) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: "Não foi possível capturar dados da integração Synkar.",
          });
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro!",
        text: "Não foi possível capturar código do pedido Synkar.",
      });
    }
  };

  usePreventNavigation(`/${pluginspace_id}/category`);

  return (
    <div className="success">
      <div
        className={`${styles.content_success} ${
          loading ? "" : styles.content_success_loading
        }`}
      >
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className={styles.success_body}>
            <CheckoutOrder position={5} name={"Conclusão"} />
            <InfoFinishedOrder
              externalCodeERP={externalCodeERP}
              orderIdExt={orderIdExt}
              status={status}
              statusOrder={statusOrder}
              config={config}
              type={type}
            />
            <SumaryOrderFinished
              totalWithoutDiscount={totalWithoutDiscount}
              total={total}
              freight={freight}
              type={type}
            />
            {gateWayInfo && (
              <InfoPayment
                gateWay={gateWayInfo}
                changePaymentValue={changePaymentValue}
                cupomDiscount={cupomDiscount}
                paymentDiscount={paymentDiscount}
                installment={installment}
                installmentValue={installmentValue}
                integrationPlanLocal={integrationPlanLocal}
              />
            )}
            {orderAddress && (
              <InfoAddressOrder
                orderAddress={orderAddress}
                type={type}
                freight={freight}
                config={config}
              />
            )}
            <InfoCustomerFinish customer={customer} />
            <InfoSeller sellerInfo={sellerInfo} />
            <InfoOrderItens order={orderFinished} config={config} />
            {config?.content.pdv.showObservation && (
              <OrderObservation
                observation={observation}
                setObservation={setObservation}
                readonly={true}
              />
            )}
          </div>
        )}
        {!loadingHeader && (
          <Menu
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
};

export { NewSuccessOrder };
